<app-toast-message #toast toastKey="permission-groups"></app-toast-message>
<p-dialog
  [(visible)]="visible"
  [modal]="true"
  [dismissableMask]="false"
  styleClass="generic-modal-container create-user-dialog"
  (onHide)="close()"
  [draggable]="false"
  [resizable]="false"
  [closable]="true"
>
  <ng-template pTemplate="header">
    <div class="modal-header">
      <h2>{{ editMode ? "Edit Country" : "Add a New Country" }}</h2>
      <!-- Changed title -->
    </div>
  </ng-template>

  <div class="modal-body">
    <form [formGroup]="countryForm" autocomplete="off">
      <!-- Changed formGroup name -->

      <div class="form-row">
        <div class="form-group">
          <label for="regoin">Region <span class="required">*</span></label>
          <p-dropdown
            [options]="filterRegions"
            optionLabel="name"
            [filter]="true"
            formControlName="region"
            placeholder="Select Region"
            [appendTo]="'body'"
            [ngClass]="{
              'ng-invalid ng-dirty':
                countryForm.controls['region'].invalid &&
                (countryForm.controls['region'].touched ||
                  countryForm.controls['region'].dirty)
            }"
          ></p-dropdown>
        </div>
        <div class="form-group">
          <label for="country">Country <span class="required">*</span></label>
          <input
            id="country"
            type="text"
            pInputText
            placeholder="Enter country"
            formControlName="country"
            [ngClass]="{
              'ng-invalid ng-dirty':
                countryForm.controls['country'].invalid &&
                (countryForm.controls['country'].touched ||
                  countryForm.controls['country'].dirty)
            }"
          />
        </div>
      </div>
    </form>
  </div>

  <ng-template pTemplate="footer">
    <div class="footer-buttons">
      <button
        pButton
        type="button"
        label="Submit"
        class="p-button-warning"
        (click)="onSubmit()"
        [disabled]="!countryForm.valid"
      ></button>
    </div>
  </ng-template>
</p-dialog>

<app-modal
  [visible]="permissionPop"
  [cancelButtonText]="'No'"
  [submitButtonText]="'Yes'"
  [header]="'Permission'"
  (onSubmit)="onSubmitPermission($event)"
  (onCancel)="onCancelPermission($event)"
>
  <div class="permission-content">
    Are you sure you want to {{ this.editMode ? "edit" : "add" }} this country
  </div>
</app-modal>
